import {
  Box,
  Button,
  CircularProgress,
  Fade,
  Modal,
  TextField,
  Typography
} from "@material-ui/core";
import { ArrowForwardIos } from "@material-ui/icons";
import React, { Component } from "react";
import DividerWithText from "./DiveiderWithText";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";

const styleModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  minWidth: "100px",
  maxWidth: "900px",
  bgcolor: "background.paper",
  borderRadius: "6px",
  boxShadow: 24,
  p: "0 0 0 4",
  outline: "none"
};

const styles = theme => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backdropFilter: "blur(8px)"
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    backdropFilter: "blur(5px)"
  }
});

class CodeAlert extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: "",
      values: ["", "", ""],
      focusedIndex: 0,
      inputRefs: [],
      openModalStart: true,
      showDetails: false,
      loading: false
    };
    this.inputRefs = [React.createRef(), React.createRef(), React.createRef()];
  }

  handleInput = (index, event) => {
    const value = event.target.value.toLowerCase();
    const newValues = [...this.state.values];
    newValues[index] = value;
    this.setState({ values: newValues });

    if (value.length === 1 && index < this.inputRefs.length - 1) {
      this.inputRefs[index + 1].current.focus();
      this.setState({ focusedIndex: index + 1, message: "" });
    } else if (value.length === 0 && index > 0) {
      this.inputRefs[index - 1].current.focus();
      this.setState({ focusedIndex: index - 1, message: "" });
    }

    if (newValues.join("").length === 3) {
      this.setState({ loading: true });
      this.props.handleSubmitCode(newValues.join(""));

      setTimeout(() => {
        if (!this.props.dataSource["rdvSmsData"]?.success) {
          this.setState({
            message: "Lettres saisies incorrectes",
            loading: false
          });
        } else {
          this.handleCloseModalStart();
          this.setState({ loading: false });
        }
      }, 1500);
    }
  };

  handleFocus = index => {
    this.setState({ focusedIndex: index });
  };

  handleOpenModalStart = () => {
    return this.setState({
      openModalStart: true
    });
  };

  handleCloseModalStart = () => {
    return this.setState({
      openModalStart: false
    });
  };
  render() {
    const { classes } = this.props;
    const { values } = this.state;
    return (
      <>
        <Modal
          className={classes.modal}
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={this.state.openModalStart}
          closeAfterTransition
        >
          <Fade in={this.state.openModalStart}>
            <Box sx={styleModal}>
              <Box
                id="body"
                style={{
                  padding: "30px 30px 10px 30px",
                  width: "385px",
                  textAlign: "center"
                }}
              >
                <div
                  style={{
                    textAlign: "center",
                    width: "100%"
                  }}
                >
                  <Typography
                    style={{
                      fontSize: "20px",
                      marginRight: 20,
                      marginLeft: 8,
                      fontWeight: "500",
                      marginBottom: 12
                    }}
                  >
                    Saisir les 3 premières lettres du nom de famille du patient
                  </Typography>
                  {[0, 1, 2].map(index => (
                    <TextField
                      key={index}
                      inputRef={this.inputRefs[index]}
                      value={values[index]}
                      onChange={e => this.handleInput(index, e)}
                      id="filled-hidden-label-normal"
                      variant="filled"
                      autoFocus={index === 0}
                      inputProps={{
                        maxLength: 1,
                        style: {
                          fontSize: "74px",
                          textTransform: "uppercase",
                          borderBottom: "2px solid #009EFF"
                        }
                      }}
                      style={{
                        margin: 4,
                        width: 90
                      }}
                    />
                  ))}
                  {this.state.loading && (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        paddingBottom: 10,
                        paddingTop: 10
                      }}
                    >
                      <CircularProgress style={{ height: 30, width: 30 }} />
                    </Box>
                  )}
                  {this.state.message && (
                    <Typography
                      style={{
                        fontSize: "16px",
                        marginRight: 20,
                        marginLeft: 8,
                        marginTop: 8,
                        marginBottom: 8
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignContent: "center",
                          color: "red"
                        }}
                      >
                        <span
                          src=""
                          alt="warning"
                          height={12}
                          style={{ marginRight: 4 }}
                        >
                          <svg
                            id="warning"
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                          >
                            <rect
                              id="Rectangle_1111"
                              data-name="Rectangle 1111"
                              width="20"
                              height="20"
                              fill="rgba(0,0,0,0)"
                            />
                            <path
                              id="Tracé_1164"
                              data-name="Tracé 1164"
                              d="M12,9.75v3.261"
                              transform="translate(-2 -1.707)"
                              fill="rgba(0,0,0,0)"
                              stroke="#e83127"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="1.5"
                            />
                            <path
                              id="Tracé_1165"
                              data-name="Tracé 1165"
                              d="M9.6,3.652,2.431,16.043A1.3,1.3,0,0,0,3.556,18H17.9a1.3,1.3,0,0,0,1.125-1.957L11.855,3.652a1.3,1.3,0,0,0-2.25,0Z"
                              transform="translate(-0.729 -0.826)"
                              fill="rgba(0,0,0,0)"
                              stroke="#e83127"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="1.5"
                            />
                            <path
                              id="Tracé_1166"
                              data-name="Tracé 1166"
                              d="M11.878,17.568a.815.815,0,1,0-.815-.815A.815.815,0,0,0,11.878,17.568Z"
                              transform="translate(-1.878 -2.514)"
                              fill="#d25c5c"
                            />
                          </svg>
                        </span>
                        <span>{this.state.message}</span>
                      </div>
                    </Typography>
                  )}
                  <Typography
                    style={{
                      fontSize: "16px",
                      marginRight: 20,
                      marginLeft: 8,
                      marginTop: 8,
                      marginBottom: 8
                    }}
                  >
                    Laura <span style={{ fontWeight: 500 }}>MER</span>
                    {`le : `}
                    <span style={{ fontWeight: 500 }}>MER</span>
                  </Typography>
                  <Typography
                    style={{
                      fontSize: "16px",
                      marginRight: 20,
                      marginLeft: 8,
                      marginBottom: 8
                    }}
                  >
                    Eric <span style={{ fontWeight: 500 }}>DE L</span>
                    {`age : `}
                    <span style={{ fontWeight: 500 }}>DEL</span>
                  </Typography>
                  <Typography
                    style={{
                      fontSize: "16px",
                      marginRight: 20,
                      marginLeft: 8,
                      marginBottom: 8
                    }}
                  >
                    Marie <span style={{ fontWeight: 500 }}>{`DA'I`}</span>
                    {`ne : `}
                    <span style={{ fontWeight: 500 }}>DAI</span>
                  </Typography>
                  <Typography
                    style={{
                      fontSize: "16px",
                      marginRight: 20,
                      marginLeft: 8,
                      marginBottom: 8
                    }}
                  >
                    Marc <span style={{ fontWeight: 500 }}>ED</span>
                    {` : `}
                    <span style={{ fontWeight: 500 }}>ED</span>
                  </Typography>
                  <DividerWithText text="ou" />
                  <Button
                    variant="text"
                    style={{
                      color: "#009EFF",
                      alignItems: "center"
                    }}
                    onClick={() => {
                      this.props.handleLogin();
                      this.handleCloseModalStart();
                    }}
                  >
                    <Typography
                      variant="button"
                      style={{
                        marginLeft: 5,
                        textTransform: "none",
                        fontSize: "16px"
                      }}
                    >
                      {`Accéder à mon compte en ligne`}
                    </Typography>
                    <ArrowForwardIos style={{ height: 15 }} />
                  </Button>
                </div>
              </Box>
            </Box>
          </Fade>
        </Modal>
      </>
    );
  }
}

CodeAlert.propTypes = {
  classes: PropTypes.any,
  dataSource: PropTypes.any,
  handleSubmitCode: PropTypes.func,
  handleLogin: PropTypes.func
};

const mapStateToProps = state => {
  return {
    dataSource: state.dataSource
  };
};

export default withStyles(styles)(connect(mapStateToProps)(CodeAlert));
